import { END_POINT } from "constants/apiConstant";
import { apiPost, apiDelete, apiGet } from "../utils/apiUtils";
const {
  UPDATE_BOM_ITEM,
  DELETE_BOM_ITEM,
  ADD_BOM_ITEM,
  SAVE_DISTRIBUTOR_CONFIG,
  GET_DISTRIBUTOR_CONFIG,
} = END_POINT;

export const addBomItemAPI = async (payload) => {
  const response = await apiPost(ADD_BOM_ITEM, payload);
  return response;
};

export const deleteBomItemAPI = async ({ id }) => {
  const response = await apiDelete(DELETE_BOM_ITEM + id);
  return response;
};

export const updateBomItemAPI = async ({
  id,
  part_number,
  qty,
  selected_distributor,
  actual_qty,
}) => {
  const payload = { id };
  if (part_number !== undefined) payload.part_number = part_number;
  if (qty !== undefined) payload.qty = qty;
  if (selected_distributor !== undefined)
    payload.selected_distributor = selected_distributor;
  if (actual_qty !== undefined)
    payload.actual_qty = actual_qty;
  const response = await apiPost(UPDATE_BOM_ITEM, payload);
  return response;
};

export const saveDistributorConfigAPI = async (payload) => {
  const response = await apiPost(SAVE_DISTRIBUTOR_CONFIG, payload);
  return response;
};

